import { createSlice } from '@reduxjs/toolkit';

interface ManagerStep {
  schedule: boolean; // se o usuário selecionou um horário
  quickAccess: boolean; // se o usuário fez login
  quickAccessOTP: boolean; // se o usuário preencheu o código de verificação
  personalData: boolean; // se o usuário preencheu os dados pessoais
  paymentMethod: boolean; // se o usuário selecionou um método de pagamento
  paymentPix: boolean; // se o usuário preencheu os dados do pagamento
  paymentCreditCard: boolean; // se o usuário preencheu os dados do cartão
  paymentMedicalInsurance: boolean; // se o usuário preencheu os dados do convênio médico
  paymentConfirmation: boolean; // se o usuário confirmou a compra
}
interface stepperState {
  clickNextStep: number;
  url: string;
  currentStep:
    | 'schedule'
    | 'quickAccess'
    | 'quickAccessOTP'
    | 'personalData'
    | 'paymentMethod'
    | 'paymentCreditCard'
    | 'paymentPix'
    | 'paymentMedicalInsurance'
    | 'paymentConfirmation';
  validSteps: ManagerStep;
  isLoading: boolean;
  enabledBackButtonOnSchedulePage: boolean;
  validForm: {
    quickAccess: {
      valid: boolean;
    };
    personalData: {
      valid: boolean;
    };
    paymentPix: {
      valid: boolean;
    };
    paymentCreditCard: {
      valid: boolean;
    };
    paymentMedicalInsurance: {
      valid: boolean;
    };
    paymentFree: {
      valid: boolean;
    };
  };
}

const initialState: stepperState = {
  clickNextStep: 0,
  url: '',
  currentStep: 'schedule',
  validSteps: {
    schedule: false,
    quickAccess: false,
    quickAccessOTP: false,
    personalData: true,
    paymentMethod: false,
    paymentPix: false,
    paymentCreditCard: false,
    paymentMedicalInsurance: false,
    paymentConfirmation: false
  },
  isLoading: false,
  enabledBackButtonOnSchedulePage: false,
  validForm: {
    quickAccess: {
      valid: false
    },
    personalData: {
      valid: false
    },
    paymentCreditCard: {
      valid: false
    },
    paymentPix: {
      valid: false
    },
    paymentMedicalInsurance: {
      valid: false
    },
    paymentFree: {
      valid: false
    }
  }
};

// com o toolkit essa função substitui o reducer
export const nextPageSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    goTo: (state, action) => {
      state.url = action.payload;
    },
    // Essa função habilita o botão
    updateValidStep: (state, action) => {
      state.validSteps = { ...state.validSteps, ...action.payload };
    },
    // Essa função efetua o submite do formulario
    updateValidForm: (state, action) => {
      state.validForm = { ...state.validForm, ...action.payload };
    },
    // Essa função seta o estado de loading
    updateLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    saveCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    clickNextStep: state => {
      state.clickNextStep += 1;
    },
    enabledBackButtonOnSchedulePage: (state, action) => {
      state.enabledBackButtonOnSchedulePage = action.payload;
    },
    resetStepper: state => {
      state.clickNextStep = 0;
      state.url = '';
      state.currentStep = 'schedule';
      state.validSteps = {
        schedule: false,
        quickAccess: false,
        quickAccessOTP: false,
        personalData: true,
        paymentMethod: false,
        paymentPix: false,
        paymentCreditCard: false,
        paymentMedicalInsurance: false,
        paymentConfirmation: false
      };
      state.isLoading = false;
      state.enabledBackButtonOnSchedulePage = false;
      state.validForm = {
        quickAccess: {
          valid: false
        },
        personalData: {
          valid: false
        },
        paymentCreditCard: {
          valid: false
        },
        paymentPix: {
          valid: false
        },
        paymentMedicalInsurance: {
          valid: false
        },
        paymentFree: {
          valid: false
        }
      };
    }
  }
});

export const {
  goTo,
  updateValidStep,
  updateValidForm,
  saveCurrentStep,
  updateLoading,
  clickNextStep,
  enabledBackButtonOnSchedulePage,
  resetStepper
} = nextPageSlice.actions;
export const nextPageReducer = nextPageSlice.reducer;
